<template>
    <div class="wrap-input" :class="customClass">
        <label
            class="label"
            :class="{
                error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid
            }"
            :for="id"
            >{{ label }}</label
        >
        <!-- <span class="label-require">*</span> -->
        <!-- <span class="label-date">วัน / เดือน / ปีพ.ศ. เกิด</span> -->
        <div class="d-flex" v-if="isInitSuccess">
            <div class="flex-fill pr-1">
                <InputDropdown
                    v-if="renderDayList"
                    v-model="dayInput"
                    addClass="ddl-date-input"
                    :inputLbl="inputLbl.date"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="isShowErrorLbl"
                    :errorInfo="errorInfoDay"
                    :itemList="dayList"
                    @input="onDayChange($event)"
                ></InputDropdown>
            </div>
            <div class="flex-fill px-1">
                <InputDropdown
                    v-if="renderMonthList"
                    v-model="monthInput"
                    addClass="ddl-date-input"
                    :inputLbl="inputLbl.month"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="isShowErrorLbl"
                    :errorInfo="errorInfoMonth"
                    :itemList="monthList"
                    @input="onMonthChange($event)"
                ></InputDropdown>
            </div>
            <div class="flex-fill pl-1">
                <InputDropdown
                    v-if="renderYearList"
                    v-model="yearInput"
                    addClass="ddl-date-input"
                    :inputLbl="inputLbl.year"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="isShowErrorLbl"
                    :errorInfo="errorInfoYear"
                    :itemList="yearList"
                    @input="onYearChange($event)"
                ></InputDropdown>
            </div>
        </div>
        <div
            class="error-text"
            v-if="isShowErrorLbl && !isFirstSave && !errorInfo.isValid"
        >
            กรุณากรอกวัน / เดือน / ปีพ.ศ. เกิด
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import InputDropdown from "./Dropdown.vue";
import moment from "moment";

/**
 * @event onDateChange
 */
export default {
    name: "DropdownDateDatepicker",
    components: {
        InputDropdown
    },
    props: {
        //v-model
        value: [Date, String],
        //props
        inputLbl: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        addClass: String
    },
    data: function() {
        return {
            id: "",
            label: "",
            content: this.value,
            customClass: "",
            isInitSuccess: false,

            dateValue: {
                day: null,
                month: null,
                year: null
            },

            errorInfoDay: {},
            errorInfoMonth: {},
            errorInfoYear: {},
            ddlInputClass: "ddl-date-input",

            dayList: [],
            monthList: [],
            yearList: [],

            dayInput: "",
            monthInput: "",
            yearInput: "",
            renderDayList: true,
            renderMonthList: true,
            renderYearList: true,
            minagedate: null
        };
    },
    created: function() {
        this.minagedate = moment()
            .startOf("days")
            .utc()
            .subtract(13, "year")
            .add(1, "day");
        this.setDayList();
        this.setMonthList();
        this.setYearList();
        this.setDateInitial();
        this.validateInput();
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name || "Label";
        this.placeholder = this.inputLbl.placeholder || "Placeholder";
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || "";

        // this.setDateInitial();
        // this.validateInput();
        this.isInitSuccess = true;
    },
    methods: {
        //#region setup
        setDayList(valMonth, valYear) {
            this.renderDayList = false;
            this.dayList = [];
            var daysInMonth;
            if(valYear%4 === 0){
                daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            } else {
                daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            }
            var maxday = valMonth ? daysInMonth[valMonth - 1] : 31;
            if (valYear && valYear == moment(this.minagedate).format("YYYY")) {
                if (valMonth == moment(this.minagedate).format("M")) {
                    maxday = moment(this.minagedate).format("D");
                }
            }
            for (let i = 1; i <= maxday; i++) {
                let d = i < 10 ? "0" + i : "" + i;
                this.dayList.push({
                    value: i + "",
                    text: d
                });
            }
            this.$nextTick().then(() => {
                this.renderDayList = true;
            });
        },
        setMonthList(valYear) {
            this.renderMonthList = false;
            var lbl = Locale.getLbl();
            var months = lbl.date.month_full;
            var list = [];
            var maxMonth =
                valYear && valYear == moment(this.minagedate).format("YYYY")
                    ? moment(this.minagedate).format("M")
                    : 12;
            for (let i = 0; i < maxMonth; i++) {
                let index = parseInt(i, 10) + 1 + "";
                list.push({
                    value: index,
                    text: months[i]
                });
            }
            this.monthList = list;
            this.$nextTick().then(() => {
                this.renderMonthList = true;
            });
        },
        setYearList() {
            var currentYear = parseInt(new Date().getFullYear(), 10);
            var yearText = currentYear;
            var localeCode = Locale.getLocaleCode();
            var yearList = [];
            if (localeCode == 1054) {
                yearText = yearText + 543;
            }
            for (var i = 0; i < 100; i++) {
                yearList.push({
                    value: currentYear - 13 - i + "",
                    text: yearText - 13 - i + ""
                });
            }
            this.yearList = yearList;
        },
        setDateInitial: function() {
            if (this.value == "Invalid Date" || Util.isEmptyStr(this.value)) {
                this.dayInput = null;
                this.monthInput = null;
                this.yearInput = null;
            } else {
                var d = this.value.getDate();
                var m = this.value.getMonth() + 1;
                var y = this.value.getFullYear();
                console.log(d, m, y);
                this.dayInput = d + "";
                this.monthInput = m + "";
                this.yearInput = y + "";
            }
        },
        //#endregion setup

        //#region event dropdown
        onDayChange: function(value) {
            // console.log('day', value);
            this.dateValue.day = value;
            this.setDateOnChange();
        },
        onMonthChange: function(value) {
            // console.log('month', value);
            this.dateValue.month = value;
            this.setDayList(value, this.dateValue.year);
            this.setDateOnChange();
        },
        onYearChange: function(value) {
            // console.log('year', value);
            this.dateValue.year = value;
            this.setDayList(null, value);
            this.setMonthList(value);
            this.setDateOnChange();
        },
        setDateOnChange: function() {
            // this.setDateIfNotValid();
            this.validateInput();
            if (
                this.dateValue.year == "" ||
                this.dateValue.month == "" ||
                this.dateValue.day == ""
            ) {
                return;
            }
            var month = parseInt(this.dateValue.month, 10) - 1;

            var datetime = new Date(
                this.dateValue.year,
                month,
                this.dateValue.day
            );
            var timestamp = DatetimeHelper.convertDateToTimeStampUnix(datetime);
            var formated = DatetimeHelper.dateFullFormat(timestamp);
            var output = {
                datetime: datetime,
                timestamp: timestamp,
                formated: formated
            };

            this.$emit("onDateChange", output);
        },
        //#endregion event dropdown

        //#region function
        // setDateIfNotValid: function() {
        //     if (this.dayInput == null || this.monthInput == null || this.yearInput == null) {
        //         return;
        //     }
        //     if (!DatetimeHelper.isDatetimeValid(this.yearInput, this.monthInput, this.dayInput)) {
        //         var lastDate = DatetimeHelper.getEndOfMonth(this.yearInput, this.monthInput);
        //         this.dayInput = lastDate.getDate();
        //         // console.log(lastDate);
        //         this.refreshInput();
        //     }
        // },
        // refreshInput: function() {
        //     this.isInitSuccess = false;
        //     this.$nextTick(() => {
        //         this.isInitSuccess = true;
        //     });
        // },
        //#endregion function

        validateInput: function() {
            console.log("validateInput");
            if (
                this.dayInput == null ||
                this.monthInput == null ||
                this.yearInput == null
            ) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;

                if (this.monthInput == null) {
                    this.errorInfoMonth.isValid = false;
                }
                if (this.yearInput == null) {
                    this.errorInfoYear.isValid = false;
                }
                if (this.dayInput == null) {
                    this.errorInfoDay.isValid = false;
                }
            } else {
                this.errorInfo.isValid = true;
                this.errorInfo.msg = this.inputLbl.required;
            }
        }
    }
};
</script>
<style lang="scss">
.wrap-input {
    .label {
        font-family: "DBHeaventRegular";
        font-size: 1.5rem;
    }
    .ddl-date-input {
        margin-top: 0px;
        .ddl-input {
            width: 100%;
            .btn-ddl-input {
                font-family: "DBHeaventRegular";
                font-size: 1.5rem;
                color: #666666;
            }
            .ddl-menu {
                font-family: "DBHeaventRegular";
                font-size: 1.5rem;
                color: #666666;
            }
        }
        .error {
            .ddl-input {
                width: 100%;
                .btn-ddl-input {
                    // color: #f00;
                    border: 1px solid #f00;
                }
            }
        }
    }
}
.label-require {
    color: #e73030;
}
</style>
